<template>
  <div>
    <el-divider content-position="left">产品选择</el-divider>
    <div class="Info info-background">
      <div class="product-el-body">
        <div class="product-info" v-if="hasProduct" @click="selected" :class="{active: true}">
          <span>{{s_product.model}}</span>
          <div class="product-img">
            <img :src="s_product.img" class="product-img">
          </div>
        </div>
      </div>
      <div class="product-el-footer">
        <span class="el-icon-search" @click="chooseProduct()"> 新增产品</span>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Product",
        props: {
            activable: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return{
                s_product: {},
                hasProduct: false,
                actived: true
            }
        },
        mounted:function() {
            if (this.$route.params.s_product) {
                this.s_product = this.$route.params.s_product
                this.hasProduct = true
            }
        },
        methods:{
            chooseProduct() {
                this.actived = true
                this.$router.push({
                    name:"ProductInfo"
                })
            },
            selected() {
                if(this.activable){
                    this.actived = !this.actived
                    this.$emit('notMyProduct')
                }
            },
            quiet(){
                if(this.activable){
                    this.actived = false
                }
            }
        },
        activated() {
            if (this.$route.params.s_product) {
                this.s_product = this.$route.params.s_product
                this.hasProduct = true
                this.$emit('notMyProduct')
            }
        }
    }
</script>

<style scoped>
  .product-el-body {
    font-size: 13px;
    color: #999;
  }
  .product-el-footer {
    font-size: 14px;
    padding: 10px;
    color: #409EFF;
  }
  .product-info {
    width: 92px;
    height: 114px;
    margin: 0 auto;
    padding: 6px;
    border: 1px solid #CACACA;
    border-radius: 8px;
  }
  .active {
    box-shadow: 0 0 4px 2px #ddd;
    border: 1px solid #2283E2;
    border-radius: 8px;
  }
</style>
